/**
 * FileManager class handles file operations including opening, closing, and updating file metadata
 */
class FileManager {
  /**
   * Open a file in a tab
   * @param {Object} node - File node object with path property
   * @param {Array} openFiles - Current array of open files
   * @param {string} activeFile - Currently active file path
   * @returns {Object} - Object with updated openFiles and activeFile
   */
  openFile(node, openFiles, activeFile) {
    if (node.type !== 'file') {
      return { openFiles, activeFile };
    }
    
    // Check if file is already open
    const existingIndex = openFiles.findIndex(f => f.path === node.path);
    if (existingIndex >= 0) {
      return { openFiles, activeFile: node.path };
    }
    
    // Add file to open files
    const newFile = { path: node.path, lineCount: null };
    const updatedOpenFiles = [...openFiles, newFile];
    
    return { openFiles: updatedOpenFiles, activeFile: node.path };
  }

  /**
   * Close a file tab
   * @param {string} path - Path of the file to close
   * @param {Array} openFiles - Current array of open files
   * @param {string} activeFile - Currently active file path
   * @returns {Object} - Object with updated openFiles and activeFile
   */
  closeFile(path, openFiles, activeFile) {
    const newOpenFiles = openFiles.filter(f => f.path !== path);
    
    // If closing active file, switch to another tab or clear
    let newActiveFile = activeFile;
    if (activeFile === path) {
      newActiveFile = newOpenFiles.length > 0 ? newOpenFiles[newOpenFiles.length - 1].path : null;
    }
    
    return { openFiles: newOpenFiles, activeFile: newActiveFile };
  }

  /**
   * Update line count for a file
   * @param {string} path - Path of the file
   * @param {number} lineCount - Line count to set
   * @param {Array} openFiles - Current array of open files
   * @returns {Array} - Updated openFiles array
   */
  updateLineCount(path, lineCount, openFiles) {
    return openFiles.map(f => 
      f.path === path ? { ...f, lineCount } : f
    );
  }
}

export default FileManager;
